import { toast } from "@cobee/cobee-ui";
import i18next from "i18next";
import authClient from "app/auth/Auth";
import { AxiosInstance, AxiosError, AxiosResponse } from "axios";
import getErrorMessage from "../config/getErrorMessage";

export default function interceptors(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.request.use(async (config) => {
    if (!authClient.isAuthenticated() && authClient.getAccessToken()) {
      await authClient.checkSession();
    }
    config.headers.Authorization = `Bearer ${authClient.getAccessToken()}`;
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error: AxiosError) => {
      const status = error.response?.status;
      const code = error.response?.data?.code;

      if (status && status >= 400 && status < 500) {
        const message = i18next.t([
          `v2.feedback-messages.errors.${getErrorMessage({ code })}`,
          "v2.feedback-messages.errors.fallback",
        ]);
        toast.show(message, { type: "error", position: "top-right" });
      }

      if (status && status >= 500) {
        const message = i18next.t("v2.feedback-messages.statusCode.500");
        toast.show(message, { type: "error", position: "top-right" });
      }

      return Promise.reject(error);
    }
  );
}
